module.exports = __webpack_public_path__ + "06dc32a96ac9bd92f442db5d37f8761d.png";